import { createDebug } from './debug';

const debug = createDebug('storage');

const hasStorage = type => {
  try {
    const storage = window[type];
    const key = '__storage_test__';
    storage.setItem(key, key);
    storage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

const storageTypes = ['localStorage', 'sessionStorage'];
const storageType = storageTypes.filter(hasStorage)[0];

debug('Using "%s" for storage', storageType);

const storage = window[storageType];

export default storage;



// WEBPACK FOOTER //
// ./src/storage.js